import { Component, OnInit } from '@angular/core';
import { DashboardCompletedEventCategoryModel } from 'src/app/models/completed-event/dashboard-completed-event-category.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

interface MatrixPoint extends DashboardCompletedEventCategoryModel {
  categoryKey: string;
}

@Component({
  selector: 'app-competency-matrix-widget',
  templateUrl: './competency-matrix-widget.component.html',
  styleUrl: './competency-matrix-widget.component.scss',
  standalone: false
})
export class CompetencyMatrixWidgetComponent implements OnInit {
  competencyMatrixData: MatrixPoint[] = [];

  allCategoryKeys: string[] = [];
  private categoryNameByKey = new Map<string, string>();

  readonly maxCategoryLabelLength: number = 12;
  readonly maxCategoriesForPolarChart: number = 20;
  readonly maxCategoriesForInclineLabels: number = 25;

  constructor(
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {}

  ngOnInit() {
    this.dashboardWidgetsDataService.getCompetencyMatrixData().subscribe(data => {
      if (data) {
        this.competencyMatrixData = data.map((x, i) => ({
          ...x,
          categoryKey: `c${i}`
        }));
        this.allCategoryKeys = this.competencyMatrixData.map(x => x.categoryKey);
        this.categoryNameByKey = new Map(
          this.competencyMatrixData.map(x => [x.categoryKey, x.categoryName])
        );
      }
    });
  }

  private getName(key: string): string {
    return this.categoryNameByKey.get(key) ?? key;
  }

  customizeCategoryLabel = (info: any): string => {
    const label = this.getName(info.value);
    return label.length > this.maxCategoryLabelLength
      ? label.slice(0, this.maxCategoryLabelLength) + '…'
      : label;
  };

  customizeCategoryHint = (info: any): string => {
    return this.getName(info.value);
  };

  customizeTooltip = (info: any) => ({
    text: `${info.seriesName}\n${this.getName(info.argument)}: ${info.value}`
  });
}